// Shrinks a photo in the browser before upload so ID scans stay small but readable.
const MAX_EDGE = 1600;

export const shrinkImage = (file) =>
  new Promise((resolve, reject) => {
    if (!file.type.startsWith("image/")) return resolve(file);
    const reader = new FileReader();
    reader.onload = () => {
      const img = new Image();
      img.onload = () => {
        const scale = Math.min(1, MAX_EDGE / Math.max(img.width, img.height));
        const canvas = document.createElement("canvas");
        canvas.width = Math.round(img.width * scale);
        canvas.height = Math.round(img.height * scale);
        canvas.getContext("2d").drawImage(img, 0, 0, canvas.width, canvas.height);
        canvas.toBlob(
          (blob) =>
            blob
              ? resolve(new File([blob], "id.jpg", { type: "image/jpeg" }))
              : reject(new Error("shrink failed")),
          "image/jpeg",
          0.8
        );
      };
      img.onerror = reject;
      img.src = reader.result;
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
